/**
 * Created by neo on 23.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { useRootStore } from '../../../Store/useRootStore';
import { useLocalized } from '../../../Hooks/useLocalized';
import { ArticleEntry } from '../../../Model/Explore/ArticleEntry';
import { ElementRenderer } from './Components/ElementRenderer';
import { Theme } from '../../../Theme/Theme';

const IntroSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(24px, 3vw, 32px);
  align-items: flex-start;
  width: 100%;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(10px, 1.5vw, 16px);
  align-items: flex-start;
  width: 100%;
`;

const Title = styled.h1`
  font-size: clamp(26px, 4vw, 36px);
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: ${Theme.Colors.textColor};
  margin: 0;
  width: 100%;
`;

const GradientLine = styled.div`
  width: min(391px, 90%);
  height: 4px;
  border-radius: 9999px;
  background: ${Theme.Colors.primary};
`;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(20px, 2.5vw, 28px);
  width: 100%;

  p {
    font-size: clamp(16px, 1.5vw, 18px);
    line-height: 1.75;
    color: #3c3c3c;
    margin: 0;
  }

  a {
    color: ${Theme.Colors.primaryDark};
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

export type ExploreContentViewArticleContentProps = {
  entry: ArticleEntry;
};

export const ExploreContentViewArticleContent: React.FC<ExploreContentViewArticleContentProps> = observer(
  ({ entry }) => {
    const title = useLocalized(entry.name);

    return (
      <IntroSection>
        <TitleContainer>
          <Title>{title}</Title>
          <GradientLine />
        </TitleContainer>
        <ContentSection>
          {entry.content.map((element) => (
            <ElementRenderer key={element.key} element={element} />
          ))}
        </ContentSection>
      </IntroSection>
    );
  },
);
